import { GetCountriesResponse } from '~/entities/responses/getCountriesResponse';
import { GetCitiesResponse } from '~/entities/responses/getCitiesResponse';

import { APIService } from './ApiService';

const currentLanguage = localStorage.getItem('i18nextLng');

export const RapidApiService = {
  async getCountries(limit: number = 1000): Promise<GetCountriesResponse> {
    const res = await APIService.call(
      'GET',
      '/geo/countries',
      undefined,
      `?languageCode=${currentLanguage?.toUpperCase()}&limit=${limit}`,
      {
        'X-RapidAPI-Key': process.env.REACT_APP_X_RapidAPI_Key,
        'X-RapidAPI-Host': process.env.REACT_APP_RapidAPI_HEADER_HOST,
      },
      true,
    );
    return res.data;
  },
  async getCities(countryId: string): Promise<GetCitiesResponse> {
    const citiesLimit: number = 1000;
    const res = await APIService.call(
      'GET',
      '/geo/cities',
      undefined,
      `?languageCode=${currentLanguage?.toUpperCase()}&limit=${citiesLimit}&countryIds=${countryId}`,
      {
        'X-RapidAPI-Key': process.env.REACT_APP_X_RapidAPI_Key,
        'X-RapidAPI-Host': process.env.REACT_APP_RapidAPI_HEADER_HOST,
      },
      true,
    );
    return res.data;
  },
};
